import { useEffect, useState } from "react";

export function Footer({ dark = false }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const fecha = now.toLocaleDateString("es-PA", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "America/Panama" });
  const hora = now.toLocaleTimeString("es-PA", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, timeZone: "America/Panama" });

  const itemCls = "whitespace-nowrap";
  const textCls = dark ? "text-slate-400" : "text-slate-400";

  return (
    <footer
      data-testid="app-footer"
      className={`flex flex-wrap items-center justify-center sm:justify-between gap-x-4 gap-y-1.5 px-4 py-2.5 text-[11px] font-mono ${
        dark ? "border-t border-white/10" : "border-t border-slate-200"
      }`}
    >
      <span className={`flex items-center gap-2 ${itemCls}`} data-testid="footer-iso-badge">
        <img src="/iso27001.png" alt="ISO 27001 Bureau Veritas Certification"
             className="h-6 w-auto rounded-sm" data-testid="footer-iso-logo" />
        <span className={`text-[9px] uppercase tracking-wider ${textCls}`}>ISO 27001 Certificado</span>
      </span>
      <span data-testid="footer-datetime" className={`${itemCls} tabular-nums ${textCls}`}>
        {fecha} · {hora}
      </span>
      <span data-testid="footer-version" className={`${itemCls} ${textCls}`}>Versión 1.5 SSCO</span>
      <a href="mailto:soporte@solocontainer.app" data-testid="footer-support-link"
         className={`${itemCls} ${dark ? "hover:text-telemetry" : "hover:text-cyan-700"} transition-colors ${textCls}`}>
        soporte@solocontainer.app
      </a>
    </footer>
  );
}
